import { render } from "./ValuationApprovals.vue?vue&type=template&id=31009baf&scoped=true"
import script from "./ValuationApprovals.vue?vue&type=script&lang=js"
export * from "./ValuationApprovals.vue?vue&type=script&lang=js"

import "./ValuationApprovals.vue?vue&type=style&index=0&id=31009baf&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31009baf"]])

export default __exports__